import React from "react";

const BarChartSkeleton = ({ bars = 18, maxHeight = 205, className }) => {
  const barHeights = React.useMemo(() => {
    return Array.from({ length: bars }).map(() =>
      Math.floor(maxHeight * (0.4 + Math.random() * 0.5))
    );
  }, [bars, maxHeight]);

  return (
    <>
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "1.5%",
          // height: maxHeight,
          width: "100%",
          padding: "10px 10px",
          borderRadius: 8,
          overflow: "hidden",
          position: "relative",
          boxSizing: "border-box",
          background: "white",
        }}
      >
        {barHeights.map((height, idx) => (
          <div
            key={idx}
            style={{
              flex: `1 1 calc(${100 / bars}% - 1.5%)`,
              height,
              borderRadius: 4,
              background:
                "linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              animationDelay: `${idx * 0.2}s`,
            }}
          />
        ))}
      </div>

      <style>{`
        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </>
  );
};

export default BarChartSkeleton;
